<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        :userCode="params.userCode"
        ref="editForm"
      />
      <div class="d2-mt">
        <div class="d2-mt">
          <el-row>
            <el-col :span="20">
              <el-button
                v-if="!isDisableEditForm"
                size="mini"
                type="primary"
                @click="save()"
              >
                {{ $l('INDEX.btn_save') || '保存' }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-sysuser-detail',
  components: {
    EditForm
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        edit:
          this.$l('form_label_edit_system_user_information') ||
          '编辑系统用户信息',
        add:
          this.$l('form_label_add_system_user_information') ||
          '添加系统用户信息',
        detail:
          this.$l('form_label_system_user_information_details') ||
          '系统用户信息详情'
      }
      return types[this.pageType]
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    }
  },
  methods: {
    goBack() {},
    save() {
      this.$refs.editForm.save()
    }
  }
}
</script>
